module.exports = __webpack_public_path__ + "static/media/mvp-character-sound.1cdab56b.mp3";